import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import styled from "styled-components";
import { getBusinessParagraph } from "../../../api/axios";
import CmsCircularProgress from "../../Common/CircularProgress";
import { showToast } from "../../../Utills/toast";
import CustomTable from "../../Common/DataTable/DataTable";

export default function ParagraphTwoView() {
    const { id, partnerId } = useParams();
    const [paragraphTwo, setParagraphTwo] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const fetchParagraphTwo = async () => {
      setIsLoading(true);
      if (!Number(id)) {
        setIsLoading(false);
        return;
      }
      try {
        const response = await getBusinessParagraph(id);
        setParagraphTwo(response.data.data[0]);
      } catch (error) {
        showToast({
          type: 'error',
          message: error.response.data.message || 'Failed to fetch paragraph two. Please try again.',
        });
      } finally {
        setIsLoading(false);
      }
    };


    useEffect(() => {
      fetchParagraphTwo();
    }, [id]);

const columns = ["Part Name", "Content"];
 const rows = [];

if (paragraphTwo && Object.keys(paragraphTwo).length > 0) {
  rows.push(["Part 1", paragraphTwo.paragraph1]);
  rows.push(["Part 2", paragraphTwo.paragraph2]);
  rows.push(["Part 3", paragraphTwo.paragraph3]);
}


    return (
     <>
      {isLoading ? <CmsCircularProgress/> : 
        <ContentWrapper>
            <BottomTitle>Paragraph 2 Section</BottomTitle>
            <CustomTable columns={columns} rows={rows} isLoading={isLoading}/>
            <ButtonWrapper>
                <Link to={`/${partnerId}/forbusiness`}>
                    <Button variant="secondary">Go Back</Button>
                </Link>
                <Link to={`/${partnerId}/forbusiness/headerparagraphtwo/edit/${id}`}>
                    <Button>{Number(id) ? 'Edit' : 'Add'} paragraph section</Button>
                </Link>
            </ButtonWrapper>
        </ContentWrapper>}
     </>
    );
    }

    const ContentWrapper = styled.div`
   justify-content: center;
   @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
    justify-content: center;
  `;
  
  const BottomTitle = styled.h3`
    text-align: center;
    padding: 10px 0;
  `;
  
  
  
  const ButtonWrapper = styled.div`
    margin: 0 auto;
    padding-top: 40px;
    display: flex;
    gap: 5rem;
    justify-content: center;
     @media (max-width: 890px) {
   justify-content: end;
    gap: 2rem;
  }
  @media (max-width: 425px) {
  gap: 1rem;
  `;